import React from "react";
import { Link } from "react-router-dom";

export default function PresaleCancel() {
  return (
    <div
      style={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: "24px",
        background: "#070b11",
        color: "#e0e8f4",
      }}
    >
      <div
        style={{
          maxWidth: 480,
          width: "100%",
          background: "rgba(255,255,255,0.03)",
          border: "1px solid rgba(239,68,68,0.25)",
          borderRadius: 16,
          padding: "32px 28px",
          textAlign: "center",
        }}
      >
        <div style={{ fontSize: 44, marginBottom: 12 }}>✕</div>
        <h1 style={{ fontSize: 22, fontWeight: 700, marginBottom: 10 }}>
          Payment Cancelled
        </h1>
        <p style={{ color: "#9aa5b5", fontSize: 14, lineHeight: 1.6, marginBottom: 18 }}>
          No charge was made. You can return to the Ego Desktop app to try
          the Pre-Sale checkout again whenever you're ready.
        </p>
        <Link
          to="/"
          style={{
            display: "inline-block",
            padding: "10px 20px",
            borderRadius: 10,
            background: "#00e5b0",
            color: "#04110d",
            fontWeight: 700,
            fontSize: 14,
            textDecoration: "none",
          }}
        >
          Return to Ego Blockchain
        </Link>
      </div>
    </div>
  );
}
